import { useMutation } from 'react-query';
import deleteCalendarEvent from '../../../requests/deleteCalendarEvent';
import { createOptions } from './utls';

const useDeleteTaskMutation = (options) => {
  return useMutation(
    ({ taskId }) => deleteCalendarEvent(taskId, 'Error'),
    createOptions(options)
  );
};

export default useDeleteTaskMutation;
